export function tokenizeSearchString(s: string): string[] {
	/**
	 * Match one of the following groups:
	 * 1. Single quoted string
	 * 2. Double quoted string
	 * 3. Double quoted string with leading dash
	 * 4. Single quoted string with leading dash
	 * 5. Any string (split by comma or new line)
	 */
	const pattern =
		/('(?:[^'\\]|\\.)*')|("(?:[^"\\]|\\.)*")|(-?"(?:[^"\\]|\\.)*")|(-?'(?:[^'\\]|\\.)*')|[^,\n\r]+/gu;

	const matches = s.match(pattern);

	if (matches) {
		// strip surrounding quotes from matched terms and remove whitespace
		return matches.map((t) => t.replaceAll(/^"|"$|^'|'$/gu, '').trim());
	}

	if (!s) return [];

	return [s];
}
